export enum CalendarDataEventObject {
  ADD_CALENDAR_TO_LIST = 'add_calendar_to_list',
  ADD_CONFERENCE_TO_EVENT = 'add_conference_to_event',
  CALENDAR_EVENT = 'calendar_event',
  CALENDAR_EVENT_MODAL = 'calendar_event_modal',
  CALENDAR_GRID = 'calendar_grid',
  CALENDAR_LIST = 'calendar_list',
  CALENDAR_NOTIFICATION = 'calendar_notification',
  CALENDAR_PREVIEW = 'calendar_preview',
  CALENDAR_VIEW_TYPE = 'calendar_view_type',
  CREATE_CALENDAR_EVENT = 'create_calendar_event',
  DAY = 'day',
  DELETE_CALENDAR_EVENT = 'delete_calendar_event',
  EMAIL_CALENDAR_PARTICIPANTS = 'email_calendar_participants',
  MONTH = 'month',
  POPOUT_CALENDAR = 'popout_calendar',
  PREVIEW_EVENT = 'preview_event',
  RESPOND_CALENDAR_INVITE = 'respond_calendar_invite',
  SEARCH_FOR_CALENDAR = 'search_for_calendar',
  UPDATE_CALENDAR_EVENT = 'update_calendar_event',
}
